import type { PropsWithChildren } from 'react';

import type { SecondarySidebarContextValue } from './sidebar-context';
import { SecondarySidebarContext } from './sidebar-context';

export function SecondarySidebarProvider({
  value,
  children,
}: PropsWithChildren<{ value: SecondarySidebarContextValue }>) {
  return <SecondarySidebarContext value={value}>{children}</SecondarySidebarContext>;
}
